import { render, staticRenderFns } from "./EntityUpdateTaskAddDialog.vue?vue&type=template&id=2f5d2062"
import script from "./EntityUpdateTaskAddDialog.vue?vue&type=script&lang=js"
export * from "./EntityUpdateTaskAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports